import { render, staticRenderFns } from "./ChatAI.vue?vue&type=template&id=19edf0d4&scoped=true"
import script from "./ChatAI.vue?vue&type=script&lang=js"
export * from "./ChatAI.vue?vue&type=script&lang=js"
import style0 from "./ChatAI.vue?vue&type=style&index=0&id=19edf0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19edf0d4",
  null
  
)

export default component.exports